export default __webpack_public_path__ + "static/media/admob-375x60.96bb2d9f.png";